import { create } from 'zustand';

interface GlobalAlertState {
  isOpen: boolean;
  message: string;
  isBlocking: boolean; // true면 배경 클릭 방지 및 확인 시 뒤로가기
  openAlert: (message: string, isBlocking?: boolean) => void;
  closeAlert: () => void;
}

export const useGlobalAlertStore = create<GlobalAlertState>(set => ({
  isOpen: false,
  message: '',
  isBlocking: false,
  openAlert: (message, isBlocking = false) => set({ isOpen: true, message, isBlocking }),
  closeAlert: () => set({ isOpen: false, message: '', isBlocking: false }),
}));
